export const SITE_CONFIG = {
  configKey: '__ATOPS_CONFIG__',
  theme: 'light',
  nav: 'vertical',
  layout: { mode: 'fluid' },
  topbar: { color: 'light' },
  menu: { color: 'dark' },
  sidenav: {
    toggle: 'full',
    size: 'default',
    user: false
  }
}; 